import React from "react";
import CrudModule, { StatusBadge } from "@/components/CrudModule";
import { money } from "@/lib/api";

export default function Suppliers() {
  return (
    <CrudModule
      title="Suppliers"
      subtitle="Purchase orders, ratings, payments & contracts."
      endpoint="suppliers"
      testid="suppliers"
      columns={[
        { key: "name", label: "Supplier" },
        { key: "contact", label: "Contact" },
        { key: "phone", label: "Phone", mono: true },
        { key: "product", label: "Product" },
        { key: "rating", label: "Rating", render: (v) => "★".repeat(Number(v) || 0) },
        { key: "balance", label: "Payable", align: "right", render: (v) => money(v) },
        { key: "status", label: "Status", render: (v) => <StatusBadge value={v} /> },
      ]}
      fields={[
        { key: "name", label: "Supplier Name", full: true },
        { key: "contact", label: "Contact Person" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "product", label: "Product", type: "select", options: ["Bulk LPG", "Cylinders", "Accessories"] },
        { key: "rating", label: "Rating (1-5)", type: "number" },
        { key: "balance", label: "Balance Payable (BZ$)", type: "number" },
        { key: "status", label: "Status", type: "select", options: ["active", "inactive"] },
      ]}
    />
  );
}
